let trackerFunction = undefined;
let defaultTrackers = [];
let isEnabled = false;
export function setupTracking(fun, trackers, enabled) {
    trackerFunction = fun;
    defaultTrackers = trackers;
    isEnabled = enabled;
}
export function arnoldWorkflowStepV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/arnold/arnold_workflow_step/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function arnoldErrorV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/arnold/arnold_error/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function arnoldCommandV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/arnold/arnold_command/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgUploadImageDragDropV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_upload_image_drag_drop/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgUploadImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_upload_image/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgSignUpV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_sign_up/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgRemoveImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_remove_image/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgRedirectToCanvaConfirmedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_redirect_to_canva_confirmed/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgRedirectToCanvaClickedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_redirect_to_canva_clicked/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgRateGoodV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_rate_good/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgRateBadV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_rate_bad/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgLoginV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_login/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageProcessedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_image_processed/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgImageDownloadV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/remove_background/rbg_image_download/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgSubscriptionPlanClickedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/pricing/rbg_subscription_plan_clicked/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgPaygPlanClickedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/pricing/rbg_payg_plan_clicked/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorZoomImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_zoom_image/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorUploadBackgroundImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_upload_background_image/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorUndoActionV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_undo_action/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorResetV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_reset/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorRedoActionV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_redo_action/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorOpenedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_opened/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorFailedMagicBrushV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_failed_magic_brush/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorClosedV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_closed/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBlurV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_apply_blur/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundImageV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_apply_background_image/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorApplyBackgroundColorV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_apply_background_color/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function rbgEditorAppliedBrushV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/remove.bg/editor/rbg_editor_applied_brush/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
export function labsIcongenRequestSentV100(data, trackers) {
    if (!isEnabled) {
        return;
    }
    const currentTrackers = trackers || defaultTrackers;
    trackerFunction({
        event: {
            schema: "https://storage.googleapis.com/kaleido-snowplow/schemas/kaleido-labs/icongenerator/labs_icongen_request_sent/jsonschema/1-0-0.json",
            data: data
        }
    }, currentTrackers);
}
